export const btnAnimation = (btns) => {
  btns.forEach((button) => {
    button.addEventListener('mouseenter', (e) => {
      const parentOffset = button.getBoundingClientRect();

      const relX = Math.round(e.clientX - parentOffset.left);
      const relY = Math.round(e.clientY - parentOffset.top);
      const offsetX = Math.round(relX + parentOffset.width / -2);

      button.style.setProperty('--left', `${relX}px`);
      button.style.setProperty('--margin-left', `${offsetX}px`);
      button.style.setProperty('--top', `${relY}px`);
      button.classList.remove('circle--hidden');
      button.classList.add('circle--visible');
    });

    button.addEventListener('mouseleave', (e) => {
      
      const parentOffset = button.getBoundingClientRect();
      const relX = e.clientX - parentOffset.left;
      const relY = e.clientY - parentOffset.top;

      button.style.setProperty('--left', `${relX}px`);
      button.style.setProperty('--top', `${relY}px`);
      button.classList.remove('circle--visible');
      button.classList.add('circle--hidden');
      
    });
  });
};
